import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	deviceData: [],
	pagination: {
		page: 1,
		limit: 10,
		total: 0,
		totalPages: 0,
	},
	loading: false,
	statusFilter: 'all', // all, production, inventory, shipped
};

const deviceDatasSlice = createSlice({
	name: "deviceDatas",
	initialState,
	reducers: {
		setDeviceData(state, action) {
			// 支援舊格式（陣列）和新格式（分頁物件）
			if (Array.isArray(action.payload)) {
				state.deviceData = action.payload;
			} else if (action.payload?.data) {
				state.deviceData = action.payload.data;
				state.pagination = action.payload.pagination || state.pagination;
			}
		},
		setPagination(state, action) {
			state.pagination = { ...state.pagination, ...action.payload };
		},
		setLoading(state, action) {
			state.loading = action.payload;
		},
		setStatusFilter(state, action) {
			state.statusFilter = action.payload;
		},
	},
});

export const { setDeviceData, setPagination, setLoading, setStatusFilter } = deviceDatasSlice.actions;
export default deviceDatasSlice.reducer;
